import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=7396e934&scoped=true"
import script from "./CommentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=7396e934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396e934",
  null
  
)

export default component.exports